// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useMemo} from 'react';
import {use_theme} from '../settings_ctx';
import {Cards, i_card, i_cls_obj} from '../ui/cards';
import {Editor} from '../../../shared/editor/editor';
import cn from 'classnames';
import styles from './about_product_banner.module.less';

interface i_about_product_props {
    title?: string;
    subtitle?: string;
}

export const About_product = (props: i_about_product_props)=>{
    const {title = 'Hola everywhere :)',
        subtitle = 'Get the access you want on any device'} = props;
    const {theme} = use_theme({def: 'hola2023'});
    const cards: i_card[] = useMemo(()=>{
        const ids = ['ext', 'mobile', 'desktop', 'tv', 'others'];
        const data = {
            ext: {
                title: 'Browser Extensions',
                to: '/products/extension',
            },
            mobile: {
                title: 'Phone Apps',
                to: '/products/mobile',
            },
            desktop: {
                title: 'Desktop Apps',
                to: '/products/desktop',
            },
            tv: {
                title: 'TV Apps',
                to: '/products/tv',
            },
            others: {
                title: 'More Products',
                to: '/products/console',
            },
        };
        return ids.map(id=>({
            id,
            img: `hola2023/products_discover_${id}.svg`,
            clickid: `about_us_products_${id}`,
            ...data[id],
        }));
    }, []);
    const cls: i_cls_obj = {
        container: styles.cards_container,
        card: styles.product_card,
        title: cn(theme.u3, styles.card_title),
        img: styles.card_img,
  };
    return <section className={styles.products}>
        <p className={cn(theme.p1, styles.title_p)}>{title}</p>
        <h3 className={cn(theme.h3, styles.products_h3)}>{subtitle}</h3>
        <Cards cards={cards} cls={cls}/>
    </section>;
};

interface i_about_product_editor_props {
    value: i_about_product_props;
    on_change: (new_val: i_about_product_props)=>void;
}

export const About_product_editor = (
{value, on_change}: i_about_product_editor_props
)=>{
    return <Editor value={value} on_change={on_change} editors={[
      {key: 'title', label: 'Title (small)', type: 'text'},
      {key: 'subtitle', label: 'Subtitle (big)', type: 'text'},
    ]}/>;
};
